import React, { useState, useEffect, useRef } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import LeadDocumentService from "../../Controller/LeadDocumentController";
import CreateLeadDocument from "./CreateLeadDocument";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function LeadDocumentPage({ LeadID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    LeadID = localStorage.getItem('LeadID');
    const tableRef = useRef();

    const [LeadDocumentList, setLeadDocument] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentLeadDocument, setCurrentLeadDocument] = useState(null);
    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (LeadDocumentList.length > 0) {
            initDataTable();
        }
    }, [LeadDocumentList]);
    const fetchLeadDocument = async () => {
        try {
            $(tableRef.current).DataTable().destroy();
            const data = await LeadDocumentService.GetAllLeadDocuments(redirectCallback, LeadID);
            setLeadDocument(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (LeadID > 0) {
            fetchLeadDocument();
        }
    }, [LeadID]);

    const handleCreateLeadDocumentClick = () => {
        setCurrentLeadDocument(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (document) => {
        setCurrentLeadDocument(document);
        setIsModalOpen(true);
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await LeadDocumentService.DeleteLeadDocument(ID, redirectCallback);
                    $(tableRef.current).DataTable().destroy();
                    fetchLeadDocument(); // Refresh the list after deletion

                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleSuccess = () => {
        fetchLeadDocument(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const getFileExtension = (fileName) => {
        const index = fileName.lastIndexOf('.');
        return index !== -1 ? fileName.substring(index) : '';
    };
    const handleDownload = async (e, docuemnt) => {
        e.stopPropagation();

        const ext = getFileExtension(docuemnt.FileName);
        const customName = `${docuemnt.Name}${ext}`;

        try {

            const response = await fetch(
                `${BASE_URL}/uploads/${CompanyID}/Lead/Document/${docuemnt.FileName}`
            );
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = customName;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateLeadDocumentClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="table-responsive">
                <table className="table m-0 table-hover" ref={tableRef}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Attached File</th>
                            <th style={{ "textAlign": "right" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {LeadDocumentList.map((docuemnt) => (
                            <tr key={docuemnt.DocID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(docuemnt) : undefined} style={{ cursor: 'pointer' }}>
                                <td>{docuemnt.Name}</td>
                                <td>{docuemnt.Description}</td>

                                <td>
                                    <a
                                        href="#"
                                        onClick={(e) => handleDownload(e, docuemnt)}
                                        style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                    >
                                        {`${docuemnt.Name}${getFileExtension(docuemnt.FileName)}`}
                                    </a>
                                </td>


                                <td className={`no-wrap ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                    <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, docuemnt.DocID)}>
                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {isModalOpen && (
                <CreateLeadDocument
                    modalInstance={modalInstance}
                    currentLeadDocument={currentLeadDocument}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    LeadID={LeadID}
                />
            )}
        </div>
    );
}

export default LeadDocumentPage;
